import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitCalendarWidgets } from '~/config/widgets/cockpit/cockpitCalendarWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_CALENDAR,
  cockpitCalendarWidgets,
  true,
);
